import useSWR from 'swr';
import { fetchData } from '../services/fetch';

// GRI-09: catálogo de séries GRI vindo do backend (gri_series), não mais uma
// lista fixa de 4 no front — série criada na tela de cadastro de indicador
// aparece aqui na hora, pros outros consumidores (filtro, badge, seleção).
export function useGriSeries() {
 const { data, isLoading, mutate } = useSWR('gri-series', fetchData);
 const series = data || [];

 const options = series.map((s) => ({ value: s.key, label: s.label }));
 const labels = options.reduce(
  (acc, option) => ({ ...acc, [option.value]: option.label }),
  {}
 );
 const colors = series.reduce(
  (acc, s) => ({ ...acc, [s.key]: s.color || 'gray' }),
  {}
 );

 return { series, options, labels, colors, isLoading, mutate };
}

export default useGriSeries;
